import React from 'react';

export default function Certicates() {
  return (
    <div>
      <h1>This is Certicates Page</h1>
    </div>
  );
}
